exports.removeDuplicatesByKey=(arr, key)=>{
  const seen = {};
  return arr.filter((item) => {
    const value = item[key];
    if (!seen.hasOwnProperty(value)) {
      seen[value] = true;
      return true;
    }
    return false;
  });
}